import { Link } from '@mui/material'
import React from 'react'
import PrimaryButton from '../../Buttons/PrimaryButton'

import './ErrorScreen.css'

function ErrorScreen(props) {

    const mailtoLink = "mailto:insightsurveyor90@gmail.com?subject=Dashboard%20Access%20Issue&body=First%20Name%3A%20*ENTER%20FIRST%20NAME*%0D%0ALast%20Name%3A%20*ENTER%20LAST%20NAME*%0D%0Aemail%3A%20*ENTER%20EMAIL%20ADDRESS*%0D%0A%0D%0A*ENTER%20DESCRIPTION%20OF%20THE%20PROBLEM%20HERE*"

  return (
    <div className='error-screen'>
        <div className='error-screen-header'>
            It looks like you are not yet authorized to access the dashboard
        </div>
        <div className='error-screen-subheader'>
            If you believe this is a mistake, please contact us <Link href = {mailtoLink}>here</Link>
        </div>
        <div className='error-screen-button'>
            <PrimaryButton text = {"Sign Out"} onClick = {props.signOut} fontSize = {"1.2vw"}/>
        </div>

    </div>
  )
}

export default ErrorScreen